import { render, staticRenderFns } from "./FolderDetails.vue?vue&type=template&id=0a2dd622&"
import script from "./FolderDetails.vue?vue&type=script&lang=js&"
export * from "./FolderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports